let config = {
  FACEBOOK_CLIENT_ID: "516351110317581",
  GOOGLE_CLIENT_ID:
    "1013192037182-e1p9nq2e4dq87aj6u3cbo8mptr7d82tk.apps.googleusercontent.com",
  Geocode_KEY: "AIzaSyAk8XubcqX5qaLo2e1KznSrlunnHpHnKqU",
};

export default config;
